export default __webpack_public_path__ + "static/media/risk-management.248e92bb.png";